module.exports = __webpack_public_path__ + "img/slogan_small.png";